import { MultipleMeetingSettings } from 'services/types/user-calendar';
import { getAxiosInstance } from './helper';

const ai = getAxiosInstance();

export function fetchMultipleMeetingSettings(
  bearer: string,
  usersId: number[],
): Promise<{ multipleMeetingSettings: MultipleMeetingSettings[] }> {
  return new Promise((resolve, reject) => {
    ai({
      method: 'POST',
      url: `/api/UserCalendar/PostMultipleMeetingSettings`,
      data: usersId,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    })
      .then(response => {
        resolve({
          multipleMeetingSettings: response.data,
        });
      })
      .catch(err => reject(err));
  });
}

export default {
  fetchMultipleMeetingSettings,
};
